import {
  Action,
  createReducer,
  on,
  createFeatureSelector,
  createSelector
} from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import * as RightSidebarActions from './suggestions.actions';
import { RightSidebar } from './suggestions.model';

export const suggestionsKey = 'rightSidebars';

export interface SuggestionsState extends EntityState<RightSidebar> {
  // additional entities state properties
  suggesteds: any[];
}

export const adapter: EntityAdapter<RightSidebar> =
  createEntityAdapter<RightSidebar>();

export const initialState: SuggestionsState = adapter.getInitialState({
  // additional entity state properties
  suggesteds: null
});

export const suggestionsReducer = createReducer(
  initialState,
  on(RightSidebarActions.loadSuggested, (state, action) => ({
    ...state,
    suggesteds: null
  })),
  on(RightSidebarActions.loadSuggestedSuccess, (state, action) => ({
    ...state,
    suggesteds: action.items
  }))
  // on(RightSidebarActions.loadGroupsSuccess,
  //   (state, action) => ({ suggesteds: action. ,...state })
  // ),
);

export const selectState =
  createFeatureSelector<SuggestionsState>(suggestionsKey);

export const { selectIds, selectEntities, selectAll, selectTotal } =
  adapter.getSelectors(selectState);

export const suggesteds = createSelector(
  selectState,
  (state) => state.suggesteds
);
